module.exports = __webpack_public_path__ + "img/portrait-of-female-student-standing-in-college-bui-p-6-ktud-5-removebg@3x.35c4806a.png";